import React from 'react'
//import { injectIntl, intlShape } from 'react-in'
import ReactRouterPropTypes from 'react-router-prop-types'
import PropTypes from 'prop-types'

import { pushHistoryWithErrorNotFound } from '../../utils/routing'

import Back from '../Buttons/Back/Back'
import Main from '../Main/Main'
import TitleMajor from '../TitleMajor/TitleMajor'
import ButtonBlueOutlineLarge from '../Buttons/ButtonBlueOutlineLarge/ButtonBlueOutlineLarge'
import Error from '../Error/Error'

import { documentTitle } from './translations'
import { LOAD_MORE } from '../../translations'

import styles from './Media.module.css'
import MediaElement from './MediaElement/MediaElement'

class Media extends React.Component {
    static propTypes = {
        videos: PropTypes.arrayOf(PropTypes.shape({
            videoId: PropTypes.string,
            title: PropTypes.string,
            videoUrl: PropTypes.string,
            link: PropTypes.string,
            publishedAt: PropTypes.string,
        })).isRequired,
        images: PropTypes.arrayOf(PropTypes.shape({
            title: PropTypes.string,
            link: PropTypes.string,
            publishedAt: PropTypes.string,
        })).isRequired,
        posts: PropTypes.arrayOf(PropTypes.shape({
            content: PropTypes.string,
            title: PropTypes.string,
            publishedAt: PropTypes.string,
        })).isRequired,
        title: PropTypes.string,
        
        isError: PropTypes.bool.isRequired,
        isErrorNotFound: PropTypes.bool.isRequired,
        isFetched: PropTypes.bool.isRequired,
        isFetching: PropTypes.bool.isRequired,

        history: ReactRouterPropTypes.history.isRequired,
        //match: ReactRouterPropTypes.match.isRequired,

        //intl: intlShape,

        fetchMedia: PropTypes.func.isRequired,
    }

    componentDidMount() {
        this.props.fetchMedia(this.getSlug(this.props))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isErrorNotFound) {
            pushHistoryWithErrorNotFound(this.props.history)
        }
        
        if (this.props.location.state !== nextProps.location.state) { // this.props.match !== nextProps.match
            this.props.fetchMedia(this.getSlug(nextProps))
        }

        this.setDocumentTitle(nextProps)
    }

    setDocumentTitle(props) {
        if (props.title) {
            document.title = documentTitle(props.title)
        }
    }

    getSlug(props) {
        const slug = props.location.pathname.toString().slice(6).replace(/^\/|\/$/g, '');
        
        if (window.__PRELOADED_STATE__.pages[slug]) {
            return window.__PRELOADED_STATE__.pages[slug]
        } else {
            pushHistoryWithErrorNotFound(props.history)
        }
    }


    renderTitle() {
        if (this.props.isError) {
            return null
        }

        const title = <span>Медиа</span>

        return (
            <TitleMajor>{title}</TitleMajor>
        )
    }

    renderMedias = () => {
        return this.props.videos.length === 0 && !this.props.isFetching ? (
            <Error>Доступных для просмотра медиа пока нет</Error>
        ) : (
            <div className={styles['Media_block']}>{this.props.videos.map((item) => this.renderMedia(item))}</div>
        )
    }
    renderMedia = (item) => {
        return (
            <div className={styles['Media_contentBlock']} key={`media-tag-${item.videoId}`}>
                <MediaElement
                    videoId={item.videoId}
                    title={item.title}
                    videoUrl={item.videoUrl}
                    link={item.link}
                    publishedAt={item.publishedAt}
                />
            </div>
        )
    }

    handleLoadMoreMediaClick = () => {
        return
    }

    renderLoadMoreButton() {
        if (this.props.videos.length === 0 || this.props.isFetched) {
            return null
        }

        return (
            <div className={styles['Media_button']}>
                <div className="ev_click-load-more"></div>
                <ButtonBlueOutlineLarge
                    onClick={this.handleLoadMoreMediaClick}
                    gtmTag={'ev_click-load-more'}
                >
                    {LOAD_MORE}
                </ButtonBlueOutlineLarge>
            </div>
        )
    }

    renderMore = () => {
        if (this.props.videos.length === 0 && !this.props.isFetched) {
            return false;
        } else {
            return this.renderLoadMoreButton()
        }
    }

    render() {
        return (
            <Main>
                <div className={styles.head}>
                    <header>
                        <Back id="Back_base" location={this.props.location} />
                        {this.renderTitle()}
                    </header>
                </div>
                <div className={styles.body}>
                    <div className={styles.inner}>
                        <div className={styles['Media_base']}>
                            <section className={styles['Media_section']}>
                                <div className={styles['Media_filteredBody']}>
                                    <div className={styles['Media_inner']}>
                                        {this.renderMedias()}
                                        {this.renderMore()}
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </Main>
        )
    }
}

export default Media
//export default injectIntl(Media)